import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { SessionDTO } from '../api/plyca-dtos-v2';

import { PlycaDataService } from '../../services/plyca.service';
import { Store } from '@ngrx/store';
import { AppState } from '../store/AppState';
import { PaginationDTO } from '../api/PaginationModel';

@Component({
  selector: 'sessionCount',
  templateUrl: 'sessionCount.template.html'
})
export class sessionCountComponent implements OnInit, OnDestroy {
  @Input() estilos: string; //  = 'style1 bg-azul1';
  @Input() descriptionKey; //  = 'Eventos';
  //  @Input() num: number; //  = 4;
  @Input() icon: string; //  = 'fa-clock-o';
  @Input() layoutClass: string;

  // para la navegacion
  @Input() link: string;
  @Input() linkParamName: string; //  = 'TIPO_TAREA';
  @Input() linkParamValue: string; //  = 'TIPO_TAREA';

  // Referencia a la lista de tareas almacenada en el store
  subscription: Subscription;
  numSesiones = '-';

  loading = true;
  error = false;
  empty = false;

  constructor(private store: Store<AppState>,
    public plycaService: PlycaDataService,
    private router: Router) { }

  ngOnInit(): void {
    this.subscription = this.plycaService
      .getSessions()
      .subscribe((result: PaginationDTO<SessionDTO>) => {
        if (result && result.content) {
          this.numSesiones = "" + result.content.length;
        } else {
          this.numSesiones = '0';
        }
        this.loading = false;
      });
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  getNumTareas(): string {
    return this.numSesiones;
  }

  widgetClass(): string {
    if (this.numSesiones === '-')
      return 'alert-secondary text-secondary';
    else
      return this.estilos;
  }

  navigate() {
    this.router.navigate(['/sessions']);
  }

  isLoading(): boolean {
    return this.loading;
  }

  isError(): boolean {
    return this.error;
  }

  isOK(): boolean {
    return !this.loading && !this.error && !this.empty;
  }

  isEmpty(): boolean {
    return this.empty;
  }
}
